<script>
import { RouterLink, RouterView } from "vue-router";
import navigator from "../layout/NavBarNew.vue"

export default {
  name: 'UserSettings',
  components: {
    navigator
  },
  data(){
    return{
      //A list of all the tabs in the left column
      settingsTabs:[
        {name: 'Notifications', link: 'notificationsLink'},
        //{name: 'Membership', link: 'memberships'},
        {name: 'Account', link: 'accountLink'},
      ],
    }
  },
  methods:{
    
  },
}

</script>

<template>
    <div class="d-flex">
    <navigator :flag="-1" />
      <div class="settings-page">
        <main class="layout-component">
          <header class="layout-title">
           <h2> Settings</h2>
          </header>

          <div class="layout-column">
            <!-- Settings content -->
             <div class="layout-column-spacer">
                <div class="left-column">
                  <li class="tabs-list">
                    <router-link class="tabs" v-for="tab in settingsTabs" :to="{name: tab.link}" :key="tab.link">
                      <div class="link">{{ tab.name }}</div>
                    </router-link>
                  </li>
                </div>
                <div class="right-column">
                  <router-view/>
                </div>
              </div>
          </div>
        </main>
        <footer>

        </footer>
      </div>
  </div>
</template>

<style scoped>
.settings-page{
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color:rgb(245, 245, 245);
    min-height: 100dvh;
    min-width: 0; 
}
.layout-component{
    align-content: start;
    justify-self: center;
    display: grid;
    flex: 1 auto;
    grid-template-columns: 100%;
    margin: 0 auto;
    width: 100%;
    max-width: 1200px;
    min-width: 700px;
    justify-items: center;
}

.layout-title{
  max-width:100%;
  width:70%;
}
.layout-column{
  display:flexbox;
  flex-direction: row;
  max-width:100%;
  width:70%;
  min-width:30%;
  height: 100vh;
  border: 2px solid #dddddd;
  border-radius: 0.5rem;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);   /*Maybe remove box shadow in the future? Personally don't think it looks the best*/
}

.layout-column-spacer{
  display:grid;
  height: 100vh;
  padding: 3rem 0 3rem 0;
  grid-template-columns: minmax(8rem, 20%) 1fr;
}

.tabs-list{
  list-style: none;
  display: grid;
}
.tabs{
  all: unset;
  padding-left: clamp(0.5rem, 2vw, 1rem);
  padding-right: clamp(1rem, 2vw, 2rem);
  padding-top: clamp(0.25rem, 1vw, 0.5rem);
  padding-bottom: clamp(0.25rem, 1vw, 0.5rem);
  margin: 0;
  cursor: pointer; /* Keeps the clickable hand cursor icon */
}
.tabs:hover{
  background-color: #ff73220f;
}
.link{
  padding-left:  clamp(0.5rem, 2vw, 1rem);
}

.router-link-exact-active .link{
  color: #ff7222;
  border-left: 2px solid #ff7222;
}

section{
  padding-left: clamp(1rem, 4vw, 3rem);
  padding-right: clamp(1rem, 4vw, 3rem);
}
.left-column{

}

.right-column{
  border-left: 2px solid #dddddd;
}

</style>


// WEBPACK FOOTER //
// src/components/settings/UserSettings.vue